export default "__VITE_ASSET__dbea9601__"